<template>
  <div class="d-flex" :style="computedStyle">
    <div class="order-column">
      <el-select
          v-model="column"
          :id="`${panelId}-order-column`"
          :class="['stretch']"
          size="medium"
      >
        <el-option
            v-for="{ key, value } in columnList"
            :key="key"
            :label="value"
            :value="key"
            :data-id="key"
        />
      </el-select>
    </div>
    <div class="order-direction" :class="{ 'mod-margin': !inDropdown }">
      <el-select
          v-model="dir"
          :id="`${panelId}-order-dir`"
          :class="['stretch']"
          size="medium"
      >
        <el-option
            v-for="{ key, value } in directions"
            :key="key"
            :label="value"
            :value="key"
            :data-id="key"
        />
      </el-select>
    </div>
  </div>
</template>
<script>
/**
 * @param ListOrder
 *
 * @description A listák sorainak rendszerezésére szolgálló komponens
 */
import { first, get, isEmpty, isEqual, isString } from 'lodash'
import { OPERATORS } from '../../../list-new/lib/list-constants'
import localStore from '../../../../utils/mixin-local-store'

export default {
  name: 'ListOrder',
  mixins: [localStore],
  props: {
    inDropdown: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      directions: [
        { key: OPERATORS.ASCENDING, value: this.$i18n.t('order_ascending') },
        { key: OPERATORS.DESCENDING, value: this.$i18n.t('order_descending') },
      ],
      parent: null,
      height: 0,
    }
  },
  computed: {
    column: {
      get() {
        return get(this.order, 'column', this.firstColumn)
      },
      set(column) {
        const dir = this.order.dir
        const order = { column, dir }
        if (!isEqual(this.order, { column, dir })) {
          this.order = order
        }
      }
    },
    columnList() {
      let list = this.setupColumns.map(({ data, title }) => ({ key: data, value: this.$i18n.t(title) }))
      if (!isEmpty(this.orderColumns)) {
        list = list.filter(({ key }) => this.orderColumns.includes(key))
      }
      return list
    },
    computedStyle() {
      const flexDirection = this.inDropdown ? 'flex-direction: column;' : 'flex-direction: row;'
      let style = `align-items: center;${flexDirection}`
      if (!this.inDropdown) {
        style +=`height: ${this.height}px;`
      }
      return style
    },
    dir: {
      get() {
        return get(this.order, 'dir', OPERATORS.ASCENDING)
      },
      set(dir) {
        const column = this.column
        const order = { column, dir }
        if (!isEqual(this.order, { column, dir })) {
          this.order = order
        }
      }
    },
    firstColumn() {
      return get(first(this.columnList), 'key')
    },
    order: {
      get() {
        return this.$get('order')
      },
      set(order) {
        this.$dispatch('setOrder', { order })
        this.updateLocalStore({ prop: 'order', value: order})
      }
    },
    orderColumns() {
      return this.$get('orderColumns')
    },
    panelId() {
      const _panelId = this.$get('panelId')
      return isString(_panelId) ? _panelId : null
    },
    setupColumns() {
      return this.$get('setupColumns')
    },
  },
  methods: {
    updateHeight() {
      this.height = this.parent && this.parent.getBoundingClientRect().height
    },
    updateParent() {
      const parentSelector = this.inDropdown ? '.dropdown-hamburger' : '.grouped-hamburger'
      this.parent = document.querySelector(`.templated-list-hamburger ${parentSelector}`)
    },
  },
  //@TODO istenverte hamburger magassagot kiegyenesiteni
  mounted() {
    window.onresize = this.updateHeight
    this.updateParent()
    this.updateHeight()
  },
}
</script>

<style>
.order-direction.mod-margin {
  margin-inline-start: -1px;
}
</style>